import { gql } from "@apollo/client";

const EVENT_PHOTOS = gql`
  query eventQuery(
    $id: ID!
    $take: Int
    $cursor: ID
    $filters: EventMediaFilters
  ) {
    event(id: $id) {
      id
      photosCount
      media(type: "IMAGE", take: $take, cursor: $cursor, filters: $filters) {
        id
        createdAt
        type
        subtype
        isExternal
        filename
        public
        aspectRatio
        canManageMedia
        contentLength
      }
    }
  }
`;

export default EVENT_PHOTOS;
